import { Tag as AntTag } from 'antd';
import classNames from 'classnames';
import React, { memo } from 'react';

import './StatusTag.less';

type StatusTagProps = {
  label: string;
  variant?: 'red' | 'grey' | 'yellow';
};

/** @see https://www.figma.com/design/Vvl7WmeGXXmS948pRsQNKE/Farmbot-Outback-Design-System?node-id=820-9826 */
function StatusTag({ label, variant }: StatusTagProps): JSX.Element {
  return (
    <AntTag className={classNames('StatusTag', variant && `StatusTag-${variant}`)}>
      {label}
    </AntTag>
  );
}

export default memo(StatusTag);
export type { StatusTagProps };
